// [CurveBeam] - [BoneVue]

// eslint-disable-next-line
export function getLast<T = any>(arr: T[]): T {
  return arr[arr.length - 1];
}
